import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import DimensionAccumulate, { ACCUMULATED_VALUE } from "@/pages/dashboard/components/DimensionAccumulate";
import { getDimensionOption } from "@/pages/dashboard/utils/utils";
import useFunnelOptionsByFilter from "@/pages/dashboard/pages/funnel/_config/useFunnelOptionsByFilter";
import { useSelector } from "umi";

interface AccumulateRef {
  value: string[]
  // setAccumulateOptions: (options: string[]) => void
}

export const accumulateRef = React.createRef<AccumulateRef>();
function DimensionOfTable(props, ref) {
  const { filterValue, onClose, defaultValue, options, gameConfig, defaultSelect, onChange, ...resetProps } = props;
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile'
  });
  useImperativeHandle(ref, () => ({
    value: accumulate,
  }));
  const [accumulate, setAccumulate] = useState([defaultValue || 'date'])
  let newOptions = options || useFunnelOptionsByFilter(filterValue, true, defaultSelect);
  // 传了gameconfig就代表要使用visible来控制显示隐藏，不传的话，是用formvalue控制的
  if (gameConfig?.default_selector) {
    newOptions = getDimensionOption(gameConfig, newOptions,dataFrame)
  }
  return (<DimensionAccumulate
    value={accumulate}
    options={newOptions}
    onChange={(value) => {
      setAccumulate(value);
      onChange?.(value);
    }
    }
    onClose={() => {
      // 发起请求, 动态列
      onClose(accumulate)
    }}
    {...resetProps}
  />)
}
export default forwardRef(DimensionOfTable);



